"use client";

import { useState } from "react";
import Image, { type ImageProps } from "next/image";
import { Skeleton } from "./skeleton";

export function ImageLoader({ src, alt, ...props }: ImageProps) {
    const [isLoading, setIsLoading] = useState(true);
    return (
        <>
            {isLoading && (
                <Skeleton className="skeleton-card flex items-center justify-center size-full absolute top-0 left-0">
                    {/* <div className="skeleton-animation"></div> */}
                    <span className="font-bold text-lg tracking-wide text-gray-300 text-center">
                        Trek Karo India
                    </span>
                </Skeleton>
            )}
            <Image
                src={src}
                alt={alt}
                loading="lazy"
                quality={80}
                {...props}
                onLoad={() => setIsLoading(false)}
                className={`${props.className} ${isLoading ? "opacity-0" : "opacity-100"} transition-opacity duration-300`}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
        </>
    );
}
